/* eslint-disable complexity */
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UsageLimitHandler } from '../usage-limit-handler';
import { CommandRegistry, Logger, Message } from '@patsnap/tahiti-core';
import { AiAgentEnvService } from '@telecom/shared/services/ai-agent-env-service/ai-agent-env-service';
import { I18nService } from '@telecom/shared/services/i18n';
import { PermissionModel } from '@/domains/permission/models/permission-model';
import { HeaderService } from '@telecom/shared/services/header-service/header-service';

@injectable()
export class UsageLimitHandlerImpl implements UsageLimitHandler {
    constructor(
        @inject(Message)
        private readonly _message: Message,
        @inject(I18nService)
        private readonly _i18nService: I18nService,
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(AiAgentEnvService)
        private readonly _aiAgentEnvService: AiAgentEnvService,
        @inject(PermissionModel)
        private readonly _permissionModel: PermissionModel,
        @inject(CommandRegistry)
        private readonly _commandRegistry: CommandRegistry,
        @inject(HeaderService)
        private readonly _headerService: HeaderService,
    ) { }

    /** 错误处理
     * @see https://confluence.zhihuiya.com/pages/viewpage.action?pageId=262417400
     * @returns
     */
    async handle() {
        if (this._headerService.account?.siteRegion === 'CN') {
            this._tryCallIframeParent();
            return;
        }
        if (this._permissionModel.modelData.tierCode === 'ENTERPRISE') {
            this._tryCallIframeParent();
            return;
        }
        const planType = this._permissionModel.modelData.tierCode;
        if (planType === 'FREE') {
            this._commandRegistry.executeCommand('usage-limit:open-modal', {
                trigger_source: 'paywall',
                header_type: 'credits_limit_upgrade',
            });
            return;
        }
        if (planType === 'PRO') {
            this._commandRegistry.executeCommand('usage-limit:open-modal', {
                trigger_source: 'paywall',
                header_type: 'credits_limit_upgrade',
            });
            return;
        }
        this._showToast();
    }
    private async _tryCallIframeParent() {
        if(this._aiAgentEnvService.isInIframe){
            this._logger.warn('运行在 AI Agent Flow 中，调用父页面的升级弹窗');
            const notShown = await this._callIframeParent();
            if (notShown === false) {
                this._logger.warn('成功弹出了升级弹窗');
            }
        } else {
            this._showToast();
        }
    }
    private _showToast() {
        this._message.error({
            message: this._i18nService.t('drafting.errors.countOverLimit'),
        });
    }

    /**
     * 调用iframe父级页面的方法
     */
    private _callIframeParent() {
        const eventName = 'usage-limit';
        return new Promise((resolve) => {
            if (this._aiAgentEnvService.isInIframe) {
                const remove = () => {
                    window.removeEventListener('message', handler);
                    window.clearTimeout(timer);
                };
                const timer = setTimeout(() => {
                    remove();
                    resolve(undefined);
                }, 5000);
                const handler = (event: MessageEvent) => {
                    const data = JSON.parse(event.data);
                    if (data.type === eventName) {
                        resolve(data.data);
                        remove();
                    }
                };
                window.addEventListener('message', handler);
                window.parent.postMessage(JSON.stringify({ type: eventName }), '*');
            }
        });
    }
}
